import { categories } from '../../assets/extensionIcons';
import file from '../../common/file';
import styles from './PercentageBar.module.scss';

interface Props {
  files: file[];
}

const PercentageBar: React.FC<Props> = ({ files }) => {
  const properties = Object.keys(categories);
  const values = Object.values(categories);

  const categoriesCounter = [0, 0, 0, 0];

  files.forEach((file) => {
    let found = 3;
    for (let i = 0; i < properties.length; i++) {
      if (values[i].includes(file.extension)) {
        found = i;
        break;
      }
    }
    categoriesCounter[found] += parseInt(file.size);
  });

  const total = Object.values(categoriesCounter).reduce((a, b) => a + b, 0);
  const percentages = Object.values(categoriesCounter).map((element) =>
    Math.ceil((element / total) * 100)
  );
  const colors = ['#617BFF', '#FF5C5C', '#2CE893', '#73767D'];

  return (
    <div className={styles['usage-line']}>
      {percentages.map((element, i) => (
        <div
          key={i}
          style={{ backgroundColor: colors[i], flex: `${element}%` }}
        ></div>
      ))}
    </div>
  );
};

export default PercentageBar;
